import React from 'react';
import {Icon} from '@fluentui/react';
interface ISearchFilterProps {
    onDelete?: () => void;
    protected?: boolean;
    color?: string;
    label?: string;
}
const SearchFilter: React.FC<ISearchFilterProps> = (props) => {
    const style = props.color ? {backgroundColor:props.color, verticalAlign: 'middle'} : {verticalAlign: 'middle'}
    const labelText = props.label ?? (typeof props.children === 'string' ? props.children : undefined);
    return (
            <div className={"ac-search-filter"} style={style}>
                <span
                    title={labelText}
                    style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        maxWidth: '250px',
                        flex: '1 1 auto',
                        minWidth: 0,
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center'
                    }}
                >
                    {props.children}
                </span>
                {!props.protected ? <Icon iconName={'StatusCircleErrorX'} className={"ac-search-filter-icon"} onClick={props.onDelete}></Icon> : <></>}
            </div>
    );
}

export default SearchFilter;